import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="gallerie" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Notre savoir faire</h2>
          <p>
            Tout le savoir faire de B2i au service de vos besoins.
          </p>
        </div>
        <div className="row">
          <div className="gallerie-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    // className="col-sm-6 col-md-4 col-lg-4"
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      alt={d.alt}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
